import { Directive, ElementRef, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appNoTranslate]',
})
export class NoTranslateDirective implements OnInit {
  constructor(private el: ElementRef<HTMLElement>, private renderer: Renderer2) {}

  ngOnInit(): void {
    // Setting the attribute at runtime (vs. writing translate="no" in the template) keeps
    // Ivy's compile-time [translate] selector match from picking this up as ngx-translate's TranslateDirective.
    this.renderer.setAttribute(this.el.nativeElement, 'translate', 'no');
  }
}
